import React, { useState, useEffect, useRef } from "react";
import { Redirect, Route, Link } from "react-router-dom";
import SelectBox from "elements/SelectBox";
import api from "services/api";
import auth from "services/auth";
import AppContext from "contexts/AppContext";
import moneyFormatter from "services/moneyFormatter";
import ls from "services/ls";
import { isMobile } from "services/isMobile";
import { __ } from "services/Translator";

import { Modal, Button, Alert, Dropdown, Form, Overlay, Tooltip, Accordion, ProgressBar } from "react-bootstrap";

export default function Cashier(props) {
  // const __ = (text) => text;

  const isAuthenticated = props.isAuthenticated;
  const userDetails = props.userDetails;
  const userBalance = props.userBalance;

  const [selectedWallet, setSelectedWalelt] = useState(null);
  const [selectItems, setSelectItems] = useState([]);

  useEffect(() => {
    if (props.userBalance.wallets.length) {
      setSelectedWalelt(props.userBalance.wallets[0].currency);
      setSelectItems(
        props.userBalance.wallets.map((item) => {
          return { label: item.currency, value: item.value };
        })
      );
    }
  }, [props.userBalance]);

  const [deleteBonusModal, setDeleteBonusModal] = useState(false);
  const deleteBonusAction = async () => {
    var response = await api.post("/delete-bonus");

    if (response.status === 200 && response.data) {
      setDeleteBonusModal(false);
    }
  };

  const [showBalanceAsFiat, setShowBalanceAsFiat] = useState(
    ls.get("showBalanceAsFiat") ? ls.get("showBalanceAsFiat") : false
  );

  const [fiatCurrencyToDisplay, setFiatCurrencyToDisplay] = useState(
    ls.get("fiatCurrencyToDisplay") ? ls.get("fiatCurrencyToDisplay") : "USD"
  );

  useEffect(() => {
    setShowBalanceAsFiat(ls.get("showBalanceAsFiat") ? ls.get("showBalanceAsFiat") : false);
    setFiatCurrencyToDisplay(ls.get("fiatCurrencyToDisplay") ? ls.get("fiatCurrencyToDisplay") : "USD");
  }, [props.trigger]);

  const toggleShowBalanceAsFiat = () => {
    ls.set("showBalanceAsFiat", !showBalanceAsFiat);
    setShowBalanceAsFiat(!showBalanceAsFiat);
    props.setTrigger(Math.random());
  };

  const [pendingWithdrawalAmount, setPendingWithdrawalAmount] = useState(null);
  const getPendingWithdrawalAmount = async () => {
    var response = await api.get("/withdrawals/pending-amount");
    if (response.status === 200) {
      setPendingWithdrawalAmount(response.data.amount);
    }
  };

  const cancelAllWithdrawals = async () => {
    hideCancelWithdrawModal();
    var response = await api.post("/withdraw/cancel");
    if (response.status === 200) {
      getPendingWithdrawalAmount();
    }
  };

  const [cancelWithdrawModal, setCancelWithdrawModal] = useState(false);

  const showCancelWithdrawModal = async () => {
    setCancelWithdrawModal(true);
  };

  const hideCancelWithdrawModal = async () => {
    setCancelWithdrawModal(false);
  };

  useEffect(() => {
    getPendingWithdrawalAmount();
  }, []);

  return (
    <>
      <div className="cashier_heading_area">
        <h3 className="tabName white">
          <svg width="28" height="33" viewBox="0 0 28 33" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M22.4121 6.8828C22.4121 6.18789 21.8488 5.6246 21.1539 5.6246H6.54263C5.84772 5.6246 5.28442 6.18789 5.28442 6.8828V11.9723C5.28442 12.6672 5.84772 13.2305 6.54263 13.2305H21.1539C21.8488 13.2305 22.4121 12.6672 22.4121 11.9723V6.8828ZM19.8957 10.7141H7.80083V8.141H19.8957V10.7141Z"
              fill="white"
            />
            <path
              d="M7.66764 15.3757H6.66372C5.96882 15.3757 5.40552 15.939 5.40552 16.6339C5.40552 17.3288 5.96882 17.8921 6.66372 17.8921H7.66764C8.36255 17.8921 8.92584 17.3288 8.92584 16.6339C8.92584 15.939 8.36255 15.3757 7.66764 15.3757Z"
              fill="white"
            />
            <path
              d="M7.66764 20.1173H6.66372C5.96882 20.1173 5.40552 20.6806 5.40552 21.3755C5.40552 22.0704 5.96882 22.6337 6.66372 22.6337H7.66764C8.36255 22.6337 8.92584 22.0704 8.92584 21.3755C8.92584 20.6806 8.36255 20.1173 7.66764 20.1173Z"
              fill="white"
            />
            <path
              d="M7.66764 24.859H6.66372C5.96882 24.859 5.40552 25.4223 5.40552 26.1172C5.40552 26.8121 5.96882 27.3754 6.66372 27.3754H7.66764C8.36255 27.3754 8.92584 26.8121 8.92584 26.1172C8.92584 25.4223 8.36255 24.859 7.66764 24.859Z"
              fill="white"
            />
            <path
              d="M14.3502 15.3757H13.3463C12.6514 15.3757 12.0881 15.939 12.0881 16.6339C12.0881 17.3288 12.6514 17.8921 13.3463 17.8921H14.3502C15.0451 17.8921 15.6084 17.3288 15.6084 16.6339C15.6084 15.939 15.045 15.3757 14.3502 15.3757Z"
              fill="white"
            />
            <path
              d="M14.3502 20.1173H13.3463C12.6514 20.1173 12.0881 20.6806 12.0881 21.3755C12.0881 22.0704 12.6514 22.6337 13.3463 22.6337H14.3502C15.0451 22.6337 15.6084 22.0704 15.6084 21.3755C15.6084 20.6806 15.045 20.1173 14.3502 20.1173Z"
              fill="white"
            />
            <path
              d="M14.3502 24.859H13.3463C12.6514 24.859 12.0881 25.4223 12.0881 26.1172C12.0881 26.8121 12.6514 27.3754 13.3463 27.3754H14.3502C15.0451 27.3754 15.6084 26.8121 15.6084 26.1172C15.6084 25.4223 15.045 24.859 14.3502 24.859Z"
              fill="white"
            />
            <path
              d="M22.2911 16.6339C22.2911 15.939 21.7278 15.3757 21.0329 15.3757H20.029C19.334 15.3757 18.7708 15.939 18.7708 16.6339C18.7708 17.3288 19.334 17.8921 20.029 17.8921H21.0329C21.7278 17.8921 22.2911 17.3288 22.2911 16.6339Z"
              fill="white"
            />
            <path
              d="M19.2727 21.561V26.1172C19.2727 26.8121 19.836 27.3754 20.5309 27.3754C21.2258 27.3754 21.7891 26.8121 21.7891 26.1172V21.561C21.7891 20.866 21.2258 20.3027 20.5309 20.3027C19.836 20.3027 19.2727 20.866 19.2727 21.561Z"
              fill="white"
            />
            <path
              d="M26.4384 22.6013C27.1333 22.6013 27.6966 22.038 27.6966 21.3431V5.42782C27.6966 2.65272 25.4389 0.395004 22.6638 0.395004H5.03281C2.25772 0.395004 0 2.65272 0 5.42782V27.5722C0 30.3473 2.25772 32.605 5.03281 32.605H22.6638C25.4389 32.605 27.6966 30.3473 27.6966 27.5712C27.6966 26.8763 27.1333 26.3135 26.4384 26.3135C25.7435 26.3135 25.1802 26.8773 25.1802 27.5722C25.1802 28.9597 24.0513 30.0886 22.6638 30.0886H5.03281C3.64527 30.0886 2.51641 28.9597 2.51641 27.5722V5.42782C2.51641 4.04027 3.64527 2.91141 5.03281 2.91141H22.6638C24.0513 2.91141 25.1802 4.04027 25.1802 5.42782V21.3431C25.1802 22.038 25.7435 22.6013 26.4384 22.6013Z"
              fill="white"
            />
          </svg>{" "}
          {__("Cashier")}
        </h3>
        <div className="switch_balance_view">
          <label className="crypto_view">{__("Crypto View")}</label>
          <Form.Check
            checked={showBalanceAsFiat}
            type="switch"
            onChange={toggleShowBalanceAsFiat}
            label="Fiat View"
            id="show_as_fiat"
          />
        </div>
      </div>

      <div className="user_blocks">
        <div className="single_block cashier_currency">
          <div className="item">
            <div className="input_label">{__("Your Balance")}</div>

            <div className="input_box">
              {!!props.userBalance.wallets?.length
                ? !props.userBalance.wallets[0].balance && props.userBalance.bonus_balance
                  ? props.userBalance.currency + props.userBalance.bonus_balance
                  : showBalanceAsFiat
                  ? moneyFormatter.convertCurrencyToFiat(
                      props.userBalance.wallets[0].balance,
                      props.userBalance.wallets[0].currency,
                      fiatCurrencyToDisplay
                    )
                  : parseFloat(props.userBalance.wallets[0].balance).toFixed(8)
                : ""}

              {!!props.userBalance.wallets?.length &&
                moneyFormatter.currencyIcon(props.userBalance.wallets[0].currency)}
            </div>
          </div>

          <div className="item">
            <div className="input_label">
              <i className="fas fa-dollar-sign"></i>
              {__("Currency")}{" "}
              <svg width="18" height="17" viewBox="0 0 18 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M13.6626 17C13.426 17.0002 13.1929 16.9433 12.9837 16.8343L9.09792 14.8234C9.06781 14.8075 9.03419 14.7993 9.00005 14.7993C8.9659 14.7993 8.93228 14.8075 8.90217 14.8234L5.01699 16.8343C4.77623 16.959 4.50481 17.0149 4.23346 16.9957C3.9621 16.9764 3.70163 16.8828 3.48152 16.7253C3.26141 16.5679 3.09045 16.3529 2.98798 16.1048C2.88552 15.8566 2.85563 15.5852 2.90171 15.3212L3.64359 11.0619C3.64929 11.0285 3.64658 10.9943 3.63571 10.9622C3.62485 10.9301 3.60614 10.9011 3.58124 10.8778L0.440433 7.8596C0.245427 7.67254 0.10753 7.43545 0.0423663 7.17518C-0.0227975 6.91491 -0.0126231 6.64187 0.0717367 6.387C0.156097 6.13214 0.311269 5.90563 0.519673 5.73314C0.728077 5.56065 0.981381 5.44908 1.25088 5.41107L5.59179 4.7905C5.62556 4.78566 5.65764 4.77279 5.68523 4.75301C5.71282 4.73322 5.7351 4.70711 5.75014 4.67694L7.69086 0.800669C7.81106 0.560371 7.9972 0.358012 8.2282 0.216506C8.45919 0.0749994 8.72581 0 8.99786 0C9.26992 0 9.53654 0.0749994 9.76753 0.216506C9.99853 0.358012 10.1847 0.560371 10.3049 0.800669L12.2468 4.67572C12.262 4.70579 12.2843 4.73182 12.3119 4.75159C12.3395 4.77136 12.3715 4.78428 12.4052 4.78927L16.7498 5.41046C17.0192 5.44869 17.2723 5.56038 17.4806 5.73289C17.6888 5.9054 17.8439 6.13186 17.9282 6.38663C18.0126 6.64141 18.0228 6.91433 17.9578 7.17453C17.8927 7.43474 17.7551 7.67183 17.5603 7.85899L14.4164 10.8753C14.3915 10.8987 14.3729 10.9277 14.362 10.9598C14.3512 10.9919 14.3484 11.0261 14.354 11.0594L15.0959 15.3187C15.1316 15.5245 15.1213 15.7355 15.0657 15.937C15.0102 16.1385 14.9107 16.3257 14.7742 16.4854C14.6378 16.6452 14.4676 16.7738 14.2755 16.8623C14.0834 16.9507 13.8741 16.9969 13.662 16.9975L13.6626 17ZM9.00005 13.5712C9.23649 13.5711 9.46935 13.628 9.67833 13.7369L13.5635 15.7472C13.5979 15.7665 13.6373 15.7754 13.6768 15.7727C13.7164 15.77 13.7542 15.7557 13.7855 15.7318C13.8181 15.7098 13.8435 15.6788 13.8585 15.6427C13.8734 15.6066 13.8773 15.5669 13.8696 15.5287L13.1271 11.2688C13.0875 11.0395 13.1048 10.8042 13.1778 10.583C13.2508 10.3618 13.3771 10.1613 13.5461 9.99876L16.69 6.98184C16.7181 6.95478 16.7379 6.92053 16.7472 6.88296C16.7566 6.84539 16.7551 6.806 16.7429 6.76923C16.7307 6.73246 16.7083 6.69978 16.6782 6.67487C16.6482 6.64997 16.6117 6.63383 16.5728 6.62828L12.2288 6.00648C11.9949 5.97314 11.7728 5.88423 11.5816 5.74745C11.3904 5.61067 11.236 5.43012 11.1315 5.2214L9.18707 1.34574C9.16966 1.31106 9.14274 1.28186 9.10936 1.26144C9.07598 1.24103 9.03747 1.23021 8.99818 1.23021C8.95888 1.23021 8.92037 1.24103 8.88699 1.26144C8.85361 1.28186 8.82669 1.31106 8.80928 1.34574L6.86856 5.22018C6.76407 5.42897 6.6095 5.60957 6.41822 5.74636C6.22693 5.88314 6.00469 5.972 5.77071 6.00525L1.42731 6.62828C1.38836 6.6337 1.35173 6.64979 1.3216 6.67471C1.29148 6.69963 1.26906 6.73238 1.25691 6.76922C1.24476 6.80607 1.24337 6.84553 1.25288 6.88312C1.2624 6.92071 1.28244 6.95492 1.31073 6.98184L4.45404 9.99876C4.62296 10.1613 4.74931 10.3618 4.82228 10.583C4.89525 10.8042 4.91264 11.0395 4.87298 11.2688L4.13048 15.5287C4.12374 15.5669 4.12806 15.6063 4.14292 15.6423C4.15779 15.6783 4.18262 15.7094 4.21458 15.7322C4.24654 15.755 4.28435 15.7684 4.32371 15.7711C4.36307 15.7737 4.40239 15.7655 4.43721 15.7472L8.32176 13.7363C8.53089 13.6279 8.76369 13.5712 9.00005 13.5712Z"
                  fill="#4DE8FF"
                />
              </svg>
            </div>
            <SelectBox
              className="form-controll input_box select_box"
              value={selectedWallet}
              onChange={(value) => props.setUsersWallet(value)}
              items={selectItems}
            />
          </div>
        </div>
        <div className="single_block cashier_balance">
          <div className="item">
            <div className="input_label">{__("Cash Balance")}</div>

            <div className="input_box">
              {!!props.userBalance.wallets?.length
                ? showBalanceAsFiat
                  ? moneyFormatter.convertCurrencyToFiat(
                      props.userBalance.wallets[0].balance,
                      props.userBalance.wallets[0].currency,
                      fiatCurrencyToDisplay
                    )
                  : parseFloat(props.userBalance.wallets[0].balance).toFixed(8)
                : ""}

              {!!props.userBalance.wallets?.length &&
                moneyFormatter.currencyIcon(props.userBalance.wallets[0].currency)}
            </div>
          </div>
          <div className="item">
            <div className="input_label">{__("Bonus Balance")}</div>
            <input
              disabled={true}
              className="form-controll input_box"
              value={props.userBalance.currency + props.userBalance.bonus_balance}
              type="text"
            />
          </div>
        </div>

        <div className="bonus_handling">
          <div className="gameLoadingProgress wagerRequirementBar">
            <div className="gameLoadingInfo">
              {__("Achieved")} {props.userBalance.wagering_requirements_achieved} {__("of")}{" "}
              {props.userBalance.wagering_requirements_total} {__("Wagering Requirements")}
            </div>
            <ProgressBar
              variant="success"
              label={Math.round(props.userBalance.wagering_percentage) + "%"}
              now={props.userBalance.wagering_percentage}
            />
          </div>
          <div className="btns">
            <Link
              onClick={() => {
                setDeleteBonusModal(true);
              }}
              className="common_btn_v1 no_margin inactive"
            >
              {__("Delete Bonus")}
            </Link>
            <div className="smallWhiteText text-end">{__("(and wagering requirement)")}</div>
          </div>
        </div>
      </div>

      <div className="cashier_buttons">
        <div className="btns">
          <Link onClick={() => props.setOpenWalletModalTab("deposit")} className="common_btn_v1 no_margin">
            {__("Deposit")}
          </Link>
          <Link onClick={() => props.setOpenWalletModalTab("withdraw")} className="common_btn_v1 no_margin inactive">
            {__("Withdraw")}
          </Link>
          <Link onClick={() => props.setShowVaultModal(true)} className="common_btn_v1 no_margin inactive">
            <svg width="14" height="30" viewBox="0 0 14 30" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M7.00011 19.2486C10.8624 19.2522 13.9964 16.1241 14 12.2618C14.002 10.1348 13.0359 8.12247 11.3748 6.79391V4.37472C11.3748 1.95859 9.4162 0 7.00011 0C4.58403 0 2.62547 1.95859 2.62547 4.37468V6.79387C-0.390752 9.20632 -0.880192 13.6072 1.53226 16.6234C2.86081 18.2844 4.87311 19.2505 7.00011 19.2486ZM4.37533 4.37468C4.37533 2.92504 5.55048 1.74986 7.00015 1.74986C8.44983 1.74986 9.62498 2.92501 9.62498 4.37468V5.76497C7.94254 5.0779 6.0578 5.0779 4.37537 5.76497V4.37468H4.37533ZM7.00011 6.99947C9.89939 6.99947 12.2497 9.3498 12.2497 12.2491C12.2497 15.1483 9.89939 17.4987 7.00011 17.4987C4.10084 17.4987 1.75051 15.1484 1.75051 12.2491C1.75342 9.35101 4.10205 7.00238 7.00011 6.99947Z"
                fill="#4DE8FF"
              />
              <path
                d="M6.12523 12.8817V14.8739C6.12523 15.3571 6.51694 15.7489 7.00016 15.7489C7.48339 15.7489 7.87509 15.3571 7.87509 14.8739V12.8817C8.71205 12.3985 8.99881 11.3283 8.51559 10.4913C8.03236 9.65437 6.96219 9.3676 6.12523 9.85083C5.28828 10.3341 5.00151 11.4043 5.48474 12.2412C5.63833 12.5072 5.85923 12.7281 6.12523 12.8817Z"
                fill="#4DE8FF"
              />
            </svg>{" "}
            {__("Vault")}
          </Link>
          <Link onClick={() => props.setShowTipModal(true)} className="common_btn_v1 no_margin inactive">
            {__("Tip")}
          </Link>
        </div>

        <div className="btns withdrawal_info">
          <div className="info input_label" style={{ marginBottom: 0 }}>
            {__("Pending withdrawals")} {parseFloat(pendingWithdrawalAmount)}
          </div>
          <Link
            onClick={() => {
              showCancelWithdrawModal();
            }}
            className="common_btn_v1 no_margin inactive"
          >
            {__("Cancel All Withdawals")}
          </Link>
        </div>
      </div>

      <Modal show={deleteBonusModal}>
        <Modal.Body className="login_modal forgot_pass">
          <div
            onClick={() => {
              setDeleteBonusModal(false);
            }}
            className="modal_close_reg small"
          >
            <svg width="17" height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M6.26872 8.99995L1.05492 3.59305C0.775612 3.3034 0.589405 2.86892 0.589405 2.43443C0.589405 1.99995 0.775612 1.56547 1.05492 1.27581C1.66009 0.648226 2.68423 0.648226 3.2894 1.27581L8.5032 6.68271L13.717 1.27581C14.3222 0.648226 15.3463 0.648226 15.9515 1.27581C16.2308 1.56547 16.417 1.99995 16.417 2.43443C16.417 2.86892 16.2308 3.3034 15.9515 3.59305L10.7377 8.99995L15.9515 14.4068C16.2308 14.6965 16.417 15.131 16.417 15.5655C16.417 15.9999 16.2308 16.4344 15.9515 16.7241C15.6722 17.0137 15.2532 17.2068 14.8342 17.2068C14.4153 17.2068 13.9963 17.0137 13.717 16.7241L8.5032 11.3172L3.2894 16.7241C2.68423 17.3517 1.66009 17.3517 1.05492 16.7241C0.775612 16.4344 0.589405 15.9999 0.589405 15.5655C0.589405 15.131 0.775612 14.6965 1.05492 14.4068L6.26872 8.99995Z"
                fill="#10294F"
              />
            </svg>
          </div>

          <div className="modal_headline">
            {__("Attention")}
            <br />
            <small>
              <small>{__("Are you sure to delete your bonus balance?")}</small>
            </small>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button
            className="common_btn gray"
            onClick={() => {
              setDeleteBonusModal(false);
            }}
          >
            {__("No")}
          </button>
          <button className="common_btn danger" onClick={deleteBonusAction}>
            {__("Yes")}
          </button>
        </Modal.Footer>
      </Modal>

      <Modal show={cancelWithdrawModal} onHide={hideCancelWithdrawModal}>
        <Modal.Body className="login_modal forgot_pass">
          <div onClick={hideCancelWithdrawModal} className="modal_close_reg small">
            <svg width="17" height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M6.26872 8.99995L1.05492 3.59305C0.775612 3.3034 0.589405 2.86892 0.589405 2.43443C0.589405 1.99995 0.775612 1.56547 1.05492 1.27581C1.66009 0.648226 2.68423 0.648226 3.2894 1.27581L8.5032 6.68271L13.717 1.27581C14.3222 0.648226 15.3463 0.648226 15.9515 1.27581C16.2308 1.56547 16.417 1.99995 16.417 2.43443C16.417 2.86892 16.2308 3.3034 15.9515 3.59305L10.7377 8.99995L15.9515 14.4068C16.2308 14.6965 16.417 15.131 16.417 15.5655C16.417 15.9999 16.2308 16.4344 15.9515 16.7241C15.6722 17.0137 15.2532 17.2068 14.8342 17.2068C14.4153 17.2068 13.9963 17.0137 13.717 16.7241L8.5032 11.3172L3.2894 16.7241C2.68423 17.3517 1.66009 17.3517 1.05492 16.7241C0.775612 16.4344 0.589405 15.9999 0.589405 15.5655C0.589405 15.131 0.775612 14.6965 1.05492 14.4068L6.26872 8.99995Z"
                fill="#10294F"
              />
            </svg>
          </div>
          <div className="modal_headline">
            {__("Attention")}
            <br />
            <small>
              <small>{__("Are you sure you wish to cancel all your pending withdrawal requests?")}</small>
            </small>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button className="common_btn gray" onClick={hideCancelWithdrawModal}>
            {__("No")}
          </button>
          <button className="common_btn danger" onClick={cancelAllWithdrawals}>
            {__("Yes")}
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
